import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { DatePicker, Form, InputNumber, Modal, ModalProps } from "antd";
import { ChangeEnum, OperateEnum } from "@/types/inventory";
import { useOrderAdd } from "../../pages/Inventory/hooks/useOrderAdd";
import dayjs from "dayjs";
import { SourceTypeEnum } from "@/types/common";
import { StoreTypeEnum } from "@/types/product";

interface Order {
  sourceId: string;
  productId: string;
  changeType: ChangeEnum;
  sourceType: SourceTypeEnum;
}

interface ChangeFormProps extends ModalProps {
  formTitle: string;
  order: Order | null;
  setOrder: (order: Order | null) => void;
  numberTip: string;
  numberPlTip: string;
}

const ChangeForm: FC<ChangeFormProps> = ({
  formTitle,
  order,
  setOrder,
  numberTip,
  numberPlTip,
  ...props
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const [number, setNumber] = useState<number>(0);
  const [date, setDate] = useState<number | null>(null);

  const { handleAddOrder } = useOrderAdd(order ? order.changeType : undefined, '', [], () => setOrder(null))

  return (
    order ? (
      <Modal
        open={!!order}
        onCancel={() => setOrder(null)}
        title={formTitle}
        onOk={() => handleAddOrder({
          arrivalAt: date ? dayjs(date).valueOf() : null,
          changeType: order.changeType,
          sourceType: order.sourceType,
          opType: OperateEnum.TRANSACTION,
          sourceId: order?.sourceId ?? '',
          items: [{
            productId: order?.productId ?? '',
            quantity: number
          }],
          scans: [],
          orderType: StoreTypeEnum.NUM
        })}
        {...props}
      >
        <Form form={form} style={{ marginTop: 16 }} name="user" autoComplete="off">
          <Form.Item label={t('warehouse.inQuantity')} name="avatar">
            <InputNumber changeOnWheel precision={0} style={{ width: '100%' }} min={1} value={number} onChange={(v) => v && setNumber(v)} placeholder={t('warehouse.plInQuantity')} />
          </Form.Item>
          <Form.Item label={t('warehouse.arrivalAt')} name="arrivalAt" hidden={order.changeType !== ChangeEnum.IN} >
            <DatePicker value={date} onChange={setDate} placeholder={t('warehouse.plArrivalAt')} />
          </Form.Item>
        </Form>
      </Modal>
    ) : null
  )
}

export default ChangeForm;